import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import logo from "../assets/logo2.png";
import dashboardIcon from "../assets/ic_dashboard.png";
import userListIcon from "../assets/ic_userlist.png";
import affirmationsIcon from "../assets/ic_affirmations.png";
import devotionsIcon from "../assets/ic_devotions.png";
import prayerGuidesIcon from "../assets/ic_prayer_guides.png";
import challengesIcon from "../assets/ic_challenges.png";
import downloadIcon from "../assets/ic_download.png";
import logoutIcon from "../assets/ic_logout.png";

const Sidebar = ({ sidebarOpen, onLogout, toggleSidebar }) => {
  const navigate = useNavigate();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const menuItems = [
    { label: "Dashboard", icon: dashboardIcon, path: "/dashboard" },
    "divider",
    { label: "User List", icon: userListIcon, path: "/dashboard/userlist" },
    "divider",
    { label: "Affirmations", icon: affirmationsIcon, path: "/dashboard/affirmations" },
    "divider",
    { label: "Devotions", icon: devotionsIcon, path: "/dashboard/devotions" },
    "divider",
    { label: "Prayer Guides", icon: prayerGuidesIcon, path: "/dashboard/prayer-guides" },
    "divider",
    { label: "Challenges", icon: challengesIcon, path: "/dashboard/challenges" },
    "divider",
    { label: "Download Resources", icon: downloadIcon, path: "/dashboard/download-resources" },
    "divider",
  ];

  const handleLogoutClick = () => {
    setShowLogoutConfirm(true);
  };

  const confirmLogout = () => {
    setShowLogoutConfirm(false);
    onLogout();
    navigate("/login");
  };

  const cancelLogout = () => {
    setShowLogoutConfirm(false);
  };

  return (
    <>
      {/* Sidebar container */}
      <div
        className={`fixed inset-y-0 left-0 z-30 w-55 bg-[#FE7A36] text-white transform ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300 ease-in-out md:relative md:translate-x-0`}
      >
        {/* Logo */}
        <div className="flex items-center justify-center h-24 border-b border-white">
          <img src={logo} alt="Logo" className="h-12 object-contain" />
        </div>

        {/* Menu */}
        <nav className="flex-1 overflow-y-auto">
          {menuItems.map((item, idx) =>
            item === "divider" ? (
              <div key={idx} className="border-t border-white" />
            ) : (
              <NavLink
                to={item.path}
                key={item.label}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-5 py-4 transition-colors ${
                    isActive ? "bg-white text-[#FE7A36]" : "text-white hover:bg-white/20"
                  }`
                }
                end={item.path === "/dashboard"}
                onClick={() => {
                  if (window.innerWidth < 768) toggleSidebar(); // auto close sidebar on mobile after click
                }}
              >
                <img src={item.icon} alt={item.label} className="w-5 h-5" />
                <span className="text-sm font-medium">{item.label}</span>
              </NavLink>
            )
          )}

          {/* Logout button */}
          <button
            onClick={handleLogoutClick}
            className="flex items-center gap-3 px-4 py-3 text-white hover:bg-white/20 w-full focus:outline-none"
          >
            <img src={logoutIcon} alt="Logout" className="w-5 h-5" />
            <span className="text-sm font-medium">Logout</span>
          </button>
        </nav>
      </div>

      {/* Overlay to close sidebar on small screens */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black opacity-30 z-20 md:hidden"
          onClick={toggleSidebar} // clicking outside closes sidebar
        />
      )}

      {/* Logout confirmation modal */}
      {showLogoutConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-40">
          <div className="bg-white rounded-md p-6 max-w-xs w-full text-center">
            <p className="mb-4 text-gray-800 font-semibold">
              Are you sure you want to logout?
            </p>
            <div className="flex justify-center gap-4">
              <button
                onClick={confirmLogout}
                className="px-4 py-2 bg-[#FE7A36] text-white rounded hover:bg-[#e76828]"
              >
                Yes
              </button>
              <button
                onClick={cancelLogout}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;
